import { Component, inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { DailyRewardsComponent } from './daily-rewards/daily-rewards.component';
import { FeaturedGamesComponent } from './featured-games/featured-games.component';
import { PointsShopComponent } from './points-shop/points-shop.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [
    DailyRewardsComponent,
    FeaturedGamesComponent,
    PointsShopComponent,
  ]
})
export class DashboardComponent {
  private authService = inject(AuthService);

  logout() {
    this.authService.logout();
  }
}
